























































































































































































































































































































































interface Ianimate {
  title: string;
  content: string;
  active: boolean;
}
import { Vue, Component } from "vue-property-decorator";
import { bannerList, linkList, orgSave } from "@/apis";
import { ElForm } from "element-ui/types/form";
import { formatUpyunUrl } from "../../utils";
import login from "./login.vue";

@Component({
  components: {
    login
  }
})
export default class Home extends Vue {
  get formatFull() {
    return (image: string) => formatUpyunUrl(image, "full");
  }
  // get imgHeight(){
  //   return ''
  // }
  private evaluate: object = [
    {
      label: "信达期货有限公司",
      value:
        "除了海量的课程，丰富的师资库，微学对我们而言最有帮助的是对于培训效果的把控。具体的课后练习、落地改进，让培训的内容实实在在地成为了员工的能力。"
    },
    {
      label: "杭州威衡科技有限公司",
      value:
        "微学提供了一个很好的线上环境，让学员们能够有安排地进行学习，并反馈一定结果。在这些过程的留存后，公司的知识库越来越丰富，线上的学习氛围也越来越好。"
    },
    {
      label: "浙江中南集团",
      value:
        "线下培训结合线上的工具，微学给了一个很好的培训解决方案。这种“新培训”的形式，让线下的培训更加具有可控性，尤其对于公司来说，效果上的提升是可见的。"
    }
  ];
  private animateList: object = [
    {
      title: "专家级别的课程",
      content:
        "每门课程由各行业前沿的专家级导师开发，保证教学内容的高质量、课程案例的高参考价值、教学理论的高度可实操性。搭配课前准备、课中实操、课后作业，以确保学员们的学习效果，帮助学员学以致用。",
      active: false
    },
    {
      title: "海量体系化课程&精准匹配",
      content:
        "平台内含1000+课程，覆盖管理学、人力资源等19大类的体系化课程；课程标签明晰，精准匹配不同岗位的横向需求、满足员工职业生涯各阶段的纵向需求。",
      active: false
    },
    {
      title: "各领域的行业专家级导师",
      content:
        "平台课程讲师具备丰富的授课经验（10年+），持有大量的行业顶级大型企业的客户案例。结合体系化知识与授课技巧，帮助客户打开思维局限，解决您行业领域的问题。",
      active: false
    },
    {
      title: "培训全流程管理&数据反馈",
      content:
        "学习圈功能，将对培训的前中后全流程提供支持，课前的预习、摸底考试、任务；课中的学习、打卡、进度排名；课后的测试、复盘、落地改进；全过程的数据报表，在辅助学员学习的同时，也帮助培训师把控培训，让培训更高效。",
      active: false
    },
    {
      title: "线上&线下结合的培训模式",
      content:
        "除了丰富的线上课程资源，我们每年还安排了大量的线下课程，结合在线学习以及导师讲课的优势，充分发挥导师的引导作用，也充分满足学员的主动性积极性，保证学习效果。",
      active: false
    },
    {
      title: "专业的班主任&助教服务",
      content:
        "线下内训课程还将提供专业的班主任以及助教，经历多次客户培训场景，全程辅助培训进行：帮助学员完成学习任务、帮助培训师收集培训数据，让学习更到位，让培训更落地。",
      active: false
    }
  ];
  private platList: object = [
    {
      title: "管理类课程",
      content:
        "基层管理（角色认知、目标计划、高效执行、职业素养）、中层管理（自我管理、团队管理、人际管理、业务管理）、高层管理（影响力、变革力、决策力）",
      active: false
    },
    {
      title: "财务类",
      content:
        "报表分析、预算管控、成本管理、资金筹划、应收账款、税务筹划、审计防范、管理会计",
      active: false
    },
    {
      title: "人力资源类",
      content:
        "组织发展、人才体系、招聘面试、薪酬设计、绩效管理、培训开发、HRD必修、新劳动法",
      active: false
    },
    {
      title: "营销类",
      content:
        "营销战略、营销团队、营销铁军特训营、营销技巧、零售连锁、客户服务、门店店长",
      active: false
    },
    {
      title: "……",
      content:
        "社群营销、生产管理、项目管理、员工职业化、总裁课等共计19个大类的体系化课程，满足企业的多样化需求",
      active: false
    }
  ];
  private knowList: object[] = [
    {
      title: "面授课",
      content: "（内训课、外派课）",
      active: false
    },
    {
      title: "录播课",
      content: "（音频录播课、视频录播课）",
      active: false
    },
    {
      title: "直播课",
      content: "（在线音频直播、在线视频直播）",
      active: false
    },
    {
      title: "系列课",
      content: "（多个子课程打包成体系化学习包）",
      active: false
    },
    {
      title: "文档解读课",
      content: "（PPT、Word、PDF等文档形式的语音解读）",
      active: false
    }
  ];

  private ruleForm: {
    organization_name: string;
    scope: string | number;
    industry: string;
    name: string;
    mobile: string;
  } = {
    organization_name: "", //公司名称
    scope: "", //公司人数
    industry: "", //行业
    name: "", //姓名
    mobile: "" //手机号
  };
  private vaildMobile = (rule: object, vlaue: string, cb: Function) => {
    if (this.ruleForm.mobile) {
      if (!/^1[3456789]\d{9}$/.test(this.ruleForm.mobile)) {
        cb(new Error("手机号码有误，请重填"));
      }
      cb();
    } else {
      cb(new Error("请输入手机号"));
    }
  };
  private rules: object = {
    organization_name: [
      { required: true, message: "请输入公司名称", trigger: "blur" }
    ],
    industry: [{ required: true, message: "请输入行业", trigger: "blur" }],
    scope: [{ required: true, message: "请输入公司规模", trigger: "blur" }],
    name: [{ required: true, message: "请输入您当姓名", trigger: "blur" }],
    mobile: [
      {
        required: true,
        validator: this.vaildMobile,
        trigger: "blur"
      }
    ]
  };
  private bannerList: object[] = [];
  private imgHeight: string = "";
  private linkList: object[] = [];
  private created() {
    this.getBanner();
    this.getLinkList();
  }
  private mounted() {
    this.$nextTick(() => {
      this.imgHeight =
        (this.$refs.imgBox as any).$el.clientWidth / (1920 / 620) + "px";
    });
  }
  public async getBanner() {
    this.bannerList = (await bannerList()).list;
  }
  public handleBanner(link: string) {
    window.open(link);
  }
  public hadnleLink(link: string) {
    window.open(link);
  }
  //友情链接列表
  public async getLinkList() {
    this.linkList = (await linkList()).list;
  }
  public submitForm(formName: any) {
    (this.$refs[formName] as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        await orgSave(this.ruleForm);
        this.$message.success("已提交");
        this.ruleForm = {
          organization_name: "", //公司名称
          scope: "", //公司人数
          industry: "", //行业
          name: "", //姓名
          mobile: "" //手机号
        };
      }
    });
  }

  public mouseenter(item: Ianimate) {
    item.active = true;
  }
  public mouseleave(item: Ianimate) {
    item.active = false;
  }
  public mouseenterPlat(item: Ianimate) {
    item.active = true;
  }
  public mouseleavePlat(item: Ianimate) {
    item.active = false;
  }
  public mouseenterKnow(item: Ianimate) {
    item.active = true;
  }
  public mouseleaveKnow(item: Ianimate) {
    item.active = false;
  }
}
